module.exports = __webpack_public_path__ + "img/4.9d44cd3d.svg";